import { porto } from 'wagmi/connectors';
import { extendConnector } from './utils.js';
export const createPortoConnector = /*#__PURE__*/ (params) => extendConnector(porto(params), 'xyz.ithaca.porto', 'Porto');
//# sourceMappingURL=porto.js.map